module.exports = __webpack_public_path__ + "media/images/user-9034d2966b5f2e6b9f8be40124ff62d4.png";